export default __webpack_public_path__ + "static/media/Shape.bda36ffe.svg";